<template>
  <v-flex xs12 sm12 md6>
    <p class="display-18 font-weight-medium mb-2 mt-2">
      {{ title }}
    </p>
    <v-combobox
      v-model="mainCatModel"
      :items="pickCat"
      item-text="Text"
      light
      flat
      outlined
      rounded
      :label="chooseCat"
      solo
      :menu-props="{
        contentClass: 'smart-combo scrollbar-17',
        closeOnClick: false,
        closeOnContentClick: false,
        openOnClick: false,
      }"
      class="rtl"
      small-chips
      required
      :rules="comboRules"
      dense
    />
  </v-flex>
</template>

<script>
import { mapState } from 'vuex';
import drushim_lodash from 'lodash';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import { comboRules } from '@/lib/rules.js';

export default {
  props: {
    title: {
      type: String,
      required: false,
      default: t('titles.smartAgent.mainChosenCat'),
    },
  },
  data() {
    return {
      mainCatModel: '',
      mainChosenCat: t('titles.smartAgent.mainChosenCat'),
      chooseCat: t('titles.smartAgent.chooseCat'),
      comboRules,
    };
  },

  computed: {
    ...mapState({
      allCategories: (state) => state.homeDrushim.allCategories,
      allSubCategories: (state) => state.homeDrushim.allSubCategories,
    }),

    pickCat() {
      const pickCatList = this.allCategories.map((obj) => {
        return {
          Text: obj.NameInHebrew,
          Code: obj.Code,
          Areas: obj.Areas.map(function (obj) {
            return {
              Category: obj.Category,
              Name: obj.NameInHebrew,
              Code: obj.Code,
              NumOfJobs: obj.numOfJobs,
            };
          }),
        };
      });
      return pickCatList;
    },
  },

  watch: {
    /**
     * update subCatModel1/2 items according to if mainCatModel1/2 changes , will also will be update mainCatModel1 if user access from step1
     */
    mainCatModel(newVal) {
      this.subCatModel = [];
      if (newVal != null) {
        this.$emit('newSelectedCategory', this.mainCatModel);
        /**
         * removed first selected  category from @pickCat list   @categories2 list
         */
        const cat2list = drushim_lodash.filter(this.pickCat, (n) => {
          return n.Code != this.mainCatModel.Code;
        });
        this.categories2 = cat2list;
      } else {
        this.subCat1Items = null;
      }
    },
  },
};
</script>
